import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {SurchargeEntityModel} from "../surcharge-entity.model";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {Config} from "../../../config";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {PricingScheduleSummaryData} from "../../pricing-schedule/pricing-schedule.data";
import {Markup_Type, Markup_Value_Type, MarkupData} from "../../markup/markup.data";

@Component({
    selector: "surcharge-edit-page",
    templateUrl: "./surcharge-edit-page.component.html",
    providers: [provideEntityModel(SurchargeEntityModel)]
})
export class SurchargeEditPageComponent extends AbstractEditPage {
    EditMode = EditMode;
    Config = Config;
    PricingScheduleSummaryData = PricingScheduleSummaryData;
    Markup_Type = Markup_Type;

    constructor(public model: SurchargeEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    getMarkupNotation(): string {
        const markupValueType: Markup_Value_Type = MarkupData.getValueType(this.model.data.modifier.type);
        return markupValueType == Markup_Value_Type.CURRENCY ? "wbo.common.currencyCode" :
            markupValueType == Markup_Value_Type.PERCENT ? "wbo.common.percent" :
                "wbo.common.empty";
    }

    modifierTypeChanged(): void {
        this.updateValueAndValidity(["modifier.value"]);
    }
}
